// Must import from moment-jalaali (not moment + side-effect), otherwise
// jYYYY/jMM tokens are treated as literal "j" + year/month → "j2026/j05/j26".
import moment from "moment-jalaali";
import i18n from "../i18n";

// Convert date to Shamsi format (YYYY/MM/DD HH:mm)
export const convertToShamsi = (dateString: string) => {
  const m = moment(dateString);
  if (!m.isValid()) return "";
  return m.format("jYYYY/jMM/jDD HH:mm");
};

// Convert date to relative time using i18n (e.g. "Just now", "5 minutes ago")
export const convertToShamsiRelative = (dateString: string) => {
  const m = moment(dateString);
  if (!m.isValid()) return "";
  const now = moment();
  const diff = now.diff(m, "minutes");

  if (diff < 1) {
    return i18n.t("time.justNow");
  }
  if (diff < 60) {
    return i18n.t("time.minutesAgo", { n: diff });
  }
  if (diff < 1440) {
    const hours = Math.floor(diff / 60);
    return i18n.t("time.hoursAgo", { n: hours });
  }
  if (diff < 43200) {
    const days = Math.floor(diff / 1440);
    return i18n.t("time.daysAgo", { n: days });
  }
  const weeks = Math.floor(diff / 10080);
  if (weeks < 4) {
    return i18n.t("time.weeksAgo", { n: weeks });
  }
  return convertToShamsi(dateString);
};

// Convert date to Shamsi format with day name
export const convertToShamsiWithDay = (dateString: string) => {
  const m = moment(dateString);
  if (!m.isValid()) return "";
  const dayNames = ["یکشنبه", "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنج‌شنبه", "جمعه", "شنبه"];
  const dayName = dayNames[m.day()];
  return `${dayName} ${m.format("jYYYY/jMM/jDD")}`;
};

// Convert date to Shamsi format with time only
export const convertToShamsiTime = (dateString: string) => {
  const m = moment(dateString);
  if (!m.isValid()) return "";
  return m.format("HH:mm");
};
